import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class SliderService {
  hideControls = new Subject<boolean>();
  containerExceedsElements = new Subject<boolean>();
}
